import IntroImage from 'assets/images/intro-pages/collision-insurance.jpg';
import { Content } from 'components/flows/collisionInsurance/IntroPage/Content';
import { FlowsIntroLayout } from 'components/flows/common/FlowsIntroLayout/FlowsIntroLayout';
import { useTranslation } from 'react-i18next';

export const CollisionInsuranceIntroPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <FlowsIntroLayout introImage={IntroImage} navigationText={t('flows.header.navigation.collisionInsurance')}>
      <Content />
    </FlowsIntroLayout>
  );
};
